import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selectAllCheckbox', 'unitCheckbox'];

  selectAllCheckboxTargetConnected(checkbox) {
    checkbox.addEventListener('ionChange', (event) => {
      this.unitCheckboxTargets.forEach(
        (checkbox) => (checkbox.checked = event.detail.checked)
      );
    });
  }

  unitCheckboxTargetConnected(checkboxFormElement) {
    checkboxFormElement.addEventListener('ionChange', (event) => {
      this.toggleSelectAllCheckbox(event);
      this.toggleDescendantCheckboxes(event);
      this.toggleAncestorCheckboxes(event);
    });
  }

  toggleSelectAllCheckbox(toggledCheckbox) {
    if (toggledCheckbox.detail.checked) {
      return;
    }

    if (this.hasSelectAllCheckboxTarget) {
      this.selectAllCheckboxTarget.checked = false;
    }
  }

  toggleDescendantCheckboxes(toggledCheckbox) {
    if (toggledCheckbox.detail.checked == true) return;

    let sibling = toggledCheckbox.currentTarget.nextElementSibling;
    while (sibling && !sibling.classList.contains('sub-units')) {
      sibling = sibling.nextElementSibling;
    }

    if (sibling == null) return;

    sibling.querySelectorAll('ion-checkbox').forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  toggleAncestorCheckboxes(toggledCheckbox) {
    if (toggledCheckbox.detail.checked == false) return;

    let parentSubUnitContainer =
      toggledCheckbox.currentTarget.closest('.sub-units');

    while (
      parentSubUnitContainer != null &&
      parentSubUnitContainer.id != 'all-units'
    ) {
      let sibling = parentSubUnitContainer.previousElementSibling;
      while (sibling && sibling.tagName !== 'ION-CHECKBOX') {
        sibling = sibling.previousElementSibling;
      }

      if (sibling == null) break;

      sibling.checked = true;
      parentSubUnitContainer =
        parentSubUnitContainer.parentElement.closest('.sub-units');
    }
  }
}
